import React from 'react';
import { Box, SxProps, Typography } from '@mui/material';
import { getNasemScoreConfig } from '../utils/reports';
import { useThemeContext } from '../contexts/BaseThemeContextProvider';

type ReportNasemScoreBadgeProps = {
  nasemScore: number;
  showUnit?: boolean;
  showBorder?: boolean;
  additionalBoxStyles?: SxProps;
  additionalTypographyStyles?: SxProps;
};

const ReportNasemScoreBadge: React.FC<ReportNasemScoreBadgeProps> = ({
  nasemScore,
  showUnit,
  showBorder=true,
  additionalBoxStyles = {},
  additionalTypographyStyles = {},
}) => {
  const { theme } = useThemeContext();
  // Define configuration (like badge text color and background color) based on nasemScore
  const { badgeBackgroundColor, badgeTextColor } = getNasemScoreConfig(nasemScore, theme);

  const renderTestUnit = () => {
    if (!showUnit) return <></>;

    return (
      <Typography
        component="span"
        sx={{
          fontSize: '12px',
          fontWeight: 400,
          lineHeight: '16px',
          color: badgeTextColor,
          display: { xs: 'none', sm: 'block' },
        }}
      >
        ng/mL
      </Typography>
    );
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: badgeBackgroundColor,
        borderRadius: '24px',
        border: showBorder ? `2px solid ${badgeTextColor}` : 'none',
        padding: '2px 8px',
        marginBottom: { xs: '8px', sm: '0' },
        ...additionalBoxStyles,
      }}
    >
      <Typography
        sx={{
          fontSize: '22px',
          fontWeight: 700,
          lineHeight: '28px',
          color: badgeTextColor,
          marginRight: '4px',
          ...additionalTypographyStyles,
        }}
      >
        {Number(nasemScore).toFixed(1)}
      </Typography>
      {renderTestUnit()}
    </Box>
  );
};

export default ReportNasemScoreBadge;
